import {

  useEffect,

  useState

} from "react";

import {

  useParams

} from "react-router-dom";

import API
from "../../services/api";

import "../../styles/AnalysisEditor.css";
import "./MatchDetailsPage.css";


import AnalysisEditor
from "../../components/analysis-editor/AnalysisEditor";


function MatchDetailsPage() {

  const { id } =
  useParams();

  const [match,
  setMatch] =

  useState(null);

const [confidence, setConfidence] =
useState(50);


  useEffect(() => {

    fetchMatch();

  }, []);

  const fetchMatch =
  async () => {

    try {

const token =
localStorage.getItem("token");

const response =
await API.get(

  `/matches/${id}`,

  {

    headers: {

      Authorization:
        `Bearer ${token}`

    }

  }

);

      setMatch(
        response.data
      );

      setConfidence(
  response.data.confidence || 50
);

    } catch (error) {

      console.log(error);

    }

  };

  if (!match) {

    return <h2>
      Chargement...
    </h2>;

  }

 const saveMatch =
async () => {

  try {

    const token =
localStorage.getItem("token");

console.log(match.analysisBlocks);

    const response =
    await API.put(

      `/matches/${match._id}`,

      {

        analysis:
        match.analysis,

         analysisBlocks:
    match.analysisBlocks,

        confidence: match.confidence,
        odd: match.odd,
        accessLevel:
        match.accessLevel,

        displayStatus:
        match.displayStatus,

        predictions:
        match.predictions

      },

    {

    headers: {

      Authorization:
        `Bearer ${token}`

    }

  }

);

    setMatch(
      response.data.match
    );

    alert(
      "Sauvegardé ✅"
    );

  } catch (error) {

    console.log(error);

  }

};


    console.log(match)

  return (


  <div className="admin-match-page">

      <h1>

  {match.homeTeam}   {" vs "}  {match.awayTeam}

      </h1>

      <h3>

        {match.country}

        {" - "}

        {match.league}

      </h3>

      <p>

        {

          new Date(
            match.matchDate
          )

          .toLocaleString()

        }

      </p>

      <hr />
<br /><br />

<select

  value={
    match.accessLevel ||
    "standard"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      accessLevel:
      e.target.value

    })

  }

>

  <option value="standard">

    Standard

  </option>

  <option value="vip">

    VIP

  </option>

</select>


<select

  value={
    match.displayStatus ||
    "non_authorise"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      displayStatus:
      e.target.value

    })

  }

>

  <option value="autorise">

    Autorisé

  </option>

  <option value="non_authorise">

    Non autorisé

  </option>

</select>

<br /><br />


      <h2>
        Analyse
      </h2>

  <AnalysisEditor
  blocks={match.analysisBlocks}
  setBlocks={(blocks) =>

    setMatch({

      ...match,

      analysisBlocks: blocks

    })

  }
/>

      <hr />

      <h2>
        Pronostics
      </h2>


<br /><br />

      {

<div>

  {/* SCORE EXACT */}

  <h3>
    Score Exact
  </h3>

  <input

    type="text"

    value={
      match.predictions
      ?.scoreExact
      ?.value || ""
    }

    onChange={(e) =>

      setMatch({

        ...match,

        predictions: {

          ...match.predictions,

          scoreExact: {

            ...match.predictions.scoreExact,

            value:
            e.target.value

          }

        }

      })

    }

  />

  <input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.scoreExact?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        scoreExact: {

          ...match.predictions.scoreExact,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

  <select

    value={
      match.predictions
      ?.scoreExact
      ?.status || "en_cours"
    }

    onChange={(e) =>

      setMatch({

        ...match,

        predictions: {

          ...match.predictions,

          scoreExact: {

            ...match.predictions.scoreExact,

            status:
            e.target.value

          }

        }

      })

    }

  >

    <option value="en_cours">

      En cours

    </option>

    <option value="reussi">

      Réussi

    </option>

    <option value="echec">

      Échec

    </option>

  </select>

  <hr />

  {/* SCORE MT */}

  <h3>
    Score MT
  </h3>

  <input

    type="text"

    value={
      match.predictions
      ?.scoreMt
      ?.value || ""
    }

    onChange={(e) =>

      setMatch({

        ...match,

        predictions: {

          ...match.predictions,

          scoreMt: {

            ...match.predictions.scoreMt,

            value:
            e.target.value

          }

        }

      })

    }

  />

  <input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.scoreMt?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        scoreMt: {

          ...match.predictions.scoreMt,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

  <select

  value={
    match.predictions
    ?.scoreMt
    ?.status || "en_cours"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        scoreMt: {

          ...match.predictions.scoreMt,

          status:
          e.target.value

        }

      }

    })

  }

>

  <option value="en_cours">

    En cours

  </option>

  <option value="reussi">

    Réussi

  </option>

  <option value="echec">

    Échec

  </option>

</select>

  <hr />


<h3>
  Mi-temps Plus de Buts
</h3>

<input

  type="text"

  placeholder="1MT / 2MT"

  value={
    match.predictions
    ?.mtPlus
    ?.value || ""
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        mtPlus: {

          ...match.predictions.mtPlus,

          value:
          e.target.value

        }

      }

    })

  }

/>

<input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.mtPlus?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        mtPlus: {

          ...match.predictions.mtPlus,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

<select

  value={
    match.predictions
    ?.mtPlus
    ?.status || "en_cours"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        mtPlus: {

          ...match.predictions.mtPlus,

          status:
          e.target.value

        }

      }

    })

  }

>

  <option value="en_cours">

    En cours

  </option>

  <option value="reussi">

    Réussi

  </option>

  <option value="echec">

    Échec

  </option>

</select>

  <hr />

  {/* BTTS */}

  <h3>
    BTTS
  </h3>

  <input

    type="text"

    value={
      match.predictions
      ?.btts
      ?.value || ""
    }

      placeholder="OUI / NON"

    onChange={(e) =>

      setMatch({

        ...match,

        predictions: {

          ...match.predictions,

          btts: {

            ...match.predictions.btts,

            value:
            e.target.value

          }

        }

      })

    }

  />

<input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.btts?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        btts: {

          ...match.predictions.btts,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

  <select

  value={
    match.predictions
    ?.btts
    ?.status || "en_cours"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        btts: {

          ...match.predictions.btts,

          status:
          e.target.value

        }

      }

    })

  }

>

  <option value="en_cours">

    En cours

  </option>

  <option value="reussi">

    Réussi

  </option>

  <option value="echec">

    Échec

  </option>

</select>


<hr />

<h3>
  Plus / Moins 2.5
</h3>

<input

  type="text"

  placeholder="Plus de 2.5"

  value={
    match.predictions
    ?.plusMoins
    ?.value || ""
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        plusMoins: {

          ...match.predictions.plusMoins,

          value:
          e.target.value

        }

      }

    })

  }

/>

<input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.plusMoins?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        plusMoins: {

          ...match.predictions.plusMoins,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

<select

  value={
    match.predictions
    ?.plusMoins
    ?.status || "en_cours"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        plusMoins: {

          ...match.predictions.plusMoins,

          status:
          e.target.value

        }

      }

    })

  }

>

  <option value="en_cours">

    En cours

  </option>

  <option value="reussi">

    Réussi

  </option>

  <option value="echec">

    Échec

  </option>

</select>

  <hr />

  

<h3>
  Résultat du Match (1N2)
</h3>

<input

  type="text"

  placeholder="1 / X / 2"

  value={
    match.predictions
    ?.resultat
    ?.value || ""
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        resultat: {

          ...match.predictions.resultat,

          value:
          e.target.value

        }

      }

    })

  }

/>

<input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.resultat?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        resultat: {

          ...match.predictions.resultat,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

<select

  value={
    match.predictions
    ?.resultat
    ?.status || "en_cours"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        resultat: {

          ...match.predictions.resultat,

          status:
          e.target.value

        }

      }

    })

  }

>

  <option value="en_cours">

    En cours

  </option>

  <option value="reussi">

    Réussi

  </option>

  <option value="echec">

    Échec

  </option>

</select>

<hr />

<h3>
  Double Chance
</h3>

<input

  type="text"

  placeholder="1X / X2 / 12"

  value={
    match.predictions
    ?.doubleChance
    ?.value || ""
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        doubleChance: {

          ...match.predictions.doubleChance,

          value:
          e.target.value

        }

      }

    })

  }

/>

<input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.doubleChance?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        doubleChance: {

          ...match.predictions.doubleChance,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

<select

  value={
    match.predictions
    ?.doubleChance
    ?.status || "en_cours"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        doubleChance: {

          ...match.predictions.doubleChance,

          status:
          e.target.value

        }

      }

    })

  }

>

  <option value="en_cours">

    En cours

  </option>

  <option value="reussi">

    Réussi

  </option>

  <option value="echec">

    Échec

  </option>

</select>

<hr />

<h3>
  HT / FT
</h3>

<input

  type="text"

  placeholder="1/X"

  value={
    match.predictions
    ?.mtFin
    ?.value || ""
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        mtFin: {

          ...match.predictions.mtFin,

          value:
          e.target.value

        }

      }

    })

  }

/>

<input
  type="number"
  step="0.01"
  placeholder="Cote"

  value={
    match.predictions?.mtFin?.odd || ""
  }

  onChange={(e)=>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        mtFin: {

          ...match.predictions.mtFin,

          odd: Number(e.target.value)

        }

      }

    })

  }
/>

<select

  value={
    match.predictions
    ?.mtFin
    ?.status || "en_cours"
  }

  onChange={(e) =>

    setMatch({

      ...match,

      predictions: {

        ...match.predictions,

        mtFin: {

          ...match.predictions.mtFin,

          status:
          e.target.value

        }

      }

    })

  }

>

  <option value="en_cours">

    En cours

  </option>

  <option value="reussi">

    Réussi

  </option>

  <option value="echec">

    Échec

  </option>

</select>
<br /><br />

<div className="form-group">

  <label>
    Fiabilité (%)
  </label>

<input
  type="number"
  value={match.confidence}

  onChange={(e) =>

    setMatch({

      ...match,

      confidence:
      Number(e.target.value)

    })

  }
/>

</div>

</div>

}


<br /><br />

<button
  onClick={saveMatch}
>

  Sauvegarder

</button>

    </div>

  );

}

export default MatchDetailsPage;
